<template>
  <div class="align_left">
    <h3>
      <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
      Image de fond du Footer
    </h3>
    <b-row>
      <b-col sm="4">
        <img :src="footer_url" />
      </b-col>
      <b-col sm="8">
        <p class="bold">Remplacer l'image de fond ?</p>
        <b-form-file
          @change="uploadImage"
          placeholder="Importer une nouvelle image de fond"
          drop-placeholder="Déposer l'image ici..."
        ></b-form-file>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  props: ["url"],
  data() {
    return {
      footer_url: "",
    };
  },
  methods: {
    uploadImage() {
      var data = new FormData();
      var _this = this;
      var file = event.target.files[0];
      data.append("image", file, file.name);
      Axios.post(
        this.$store.state.base_url + "/admin/uploadImage.php",
        data
      ).then(function (response) {
        if (response.data.length > 0) {
          var url = "https://sportips.fr/race/uploads/img/" + response.data;
          _this.$root.$el.style.setProperty("--footer-image", "url('"+url+"')");
          _this.footer_url = url;
          _this.$emit("changeFooterUrl", url);
        }
      });
    },
  },
  mounted() {
    this.footer_url = this.url;
  },
};
</script>

<style lang="sass" scoped>
</style>